"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguages = getLanguages;
exports.getLanguagesWithRetry = getLanguagesWithRetry;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const index_1 = require("../index");
const constants_1 = require("../../utils/retryPolicy/constants");
const errors_1 = require("../../utils/retryPolicy/errors");
const sleep_1 = require("../../utils/sleep");
async function getLanguages() {
    const api = index_1.ApiManager.getApi(betweb_openapi_axios_1.LanguagesApi);
    return await api.getLanguages();
}
async function getLanguagesWithRetry(options) {
    const { maxAttempts = constants_1.MAX_ATTEMPTS, minInterval = constants_1.MIN_INTERVAL, maxInterval = constants_1.MAX_INTERVAL, factor = constants_1.FACTOR, randomize = constants_1.RANDOMIZE, } = options;
    let currentAttempt = 0;
    async function makeRequest() {
        try {
            const { data } = await getLanguages();
            return data;
        }
        catch (e) {
            if (currentAttempt >= maxAttempts) {
                throw new errors_1.MaxAttemptsError(maxAttempts);
            }
            let delay = Math.round(factor ** currentAttempt * minInterval);
            if (randomize) {
                delay = Math.round(Math.random() * 100 + delay);
            }
            delay = Math.min(delay, maxInterval);
            console.warn(`[${currentAttempt}] Languages need to retry. Next attempt in ${delay}`);
            await (0, sleep_1.sleep)(delay);
            currentAttempt += 1;
            return await makeRequest();
        }
    }
    return await makeRequest();
}
//# sourceMappingURL=api.js.map